import './MobileMenuButton.scss';

import cn from 'classnames';
import React from 'react';

import Button from '@/common/components/atoms/Button/Button';
import { ReactComponent as BurgerSvg } from '@/ebat/assets/icons/burger.svg';
import { ReactComponent as CloseSvg } from '@/ebat/assets/icons/close.svg';
import MobileMenu from '@/ebat/components/blocks/Header/MobileMenu/MobileMenu';
import {
  MENU_NAME_MOBILE,
  MENU_TYPE_DRAWER,
} from '@/ebat/contexts/Header/HeaderMenuContext/HeaderMenuContext';
import useHeaderMenuToggle from '@/ebat/hooks/header/useHeaderMenuToogle';

import {
  MobileMenuButtonDefaultProps,
  MobileMenuButtonPropTypes,
} from './MobileMenuButton.proptypes';

const MobileMenuButton = ({ className }) => {
  const { isOpen, handleToggle } = useHeaderMenuToggle(
    MENU_NAME_MOBILE,
    MENU_TYPE_DRAWER,
    'left',
    <MobileMenu />,
  );

  return (
    <Button
      className={cn(className, 'mobile-menu-button', {
        'mobile-menu-button--open': isOpen,
      })}
      context="mobile-menu-button"
      value={cn({ opened: isOpen }, { closed: !isOpen })}
      onClick={handleToggle}
    >
      {isOpen ? (
        <CloseSvg className="mobile-menu-button__icon" />
      ) : (
        <BurgerSvg className="mobile-menu-button__icon" />
      )}
    </Button>
  );
};

MobileMenuButton.defaultProps = {
  ...MobileMenuButtonDefaultProps,
};

MobileMenuButton.propTypes = {
  ...MobileMenuButtonPropTypes,
};

export default MobileMenuButton;
